import { format, parse } from "date-fns"
import { formatDate } from "src/main/Billing/Items/helpers"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const paymentDateText = (invoice) => {
  if (invoice.displayStatus === "Processing") {
    return "(Processing)"
  }

  if (invoice.settledAtLocalTime) {
    const settledAtDate = parse(
      invoice.settledAtLocalTime.split(" ")[0],
      "MM/dd/yyyy",
      new Date()
    )

    return formatDate(settledAtDate)
  }
}

const paymentMethodText = (invoice) => {
  if (["Settled", "Processing"].includes(invoice.displayStatus)) {
    return invoice.paymentMethod?.title || "Offline Payment"
  }
}

export const formatPaymentData = ({ invoice, presentmentCurrency }) => {
  const paymentAmount = formatCurrencyFromMinorUnits({
    amount: invoice.totalAmount - invoice.balance,
    currency: presentmentCurrency,
  })

  const paymentDate = paymentDateText(invoice)

  const paymentMethod = paymentMethodText(invoice)

  const paymentSubtitle = [paymentDate, paymentMethod].filter(Boolean).join(" ")

  return {
    paymentAmount,
    paymentSubtitle,
  }
}

export const reportGeneratedText = () => {
  const todayFormatted = format(new Date(), "MM/dd/yyyy")

  return `Report generated: ${todayFormatted}`
}

export const statusFilterText = (statusFilters) => {
  if (statusFilters.length === 0) return null

  const statusText = statusFilters.length === 1 ? "Status" : "Statuses"

  return `${statusText}: ${statusFilters.join(", ")}`
}
